import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import {
  toggleDrawBuilding,
  drawBuildingGetPoint,
  drawBuildingData,
  drawBuildingPDF,
  drawBuildingValidate,
} from '../../../../actions/mapTools';
import { setPrintStatus } from '../../../../actions/printSettings';
import s from '../SideDescription.scss';

class BuildingDraw extends Component {
  constructor(props) {
    super(props);
    this.state = {
      buildingDrawTool: this.props.buildingDrawTool,
      toggleDrawPanel: false,
      isDataValid: null,
      poprawnoscProjektu: null,
      daneInvestycji: {
        kondygnacje: {
          dane: null,
          valid: true,
        },
        typDachu: {
          dane: null,
          valid: true,
        },
        katDachu: {
          dane: null,
          valid: true,
        },
        intersekcjaValid: true,
        projektValid: false,
      },
      intl: this.props.intl,
    };
  }

  componentWillReceiveProps(nextProps) {
    if (JSON.stringify(nextProps.buildingDrawTool) !== JSON.stringify(this.state.buildingDrawTool)) {
      this.setState({ buildingDrawTool: nextProps.buildingDrawTool, toggleDrawPanel: false });
    }
    if (JSON.stringify(nextProps.intl) !== JSON.stringify(this.state.intl)) {
      this.setState({
        intl: nextProps.intl,
      });
    }
  }

  stopDrawBulding = () => {
    // kończymy projektowanie i validujemy
    this.props.toggleDrawBuilding(false);
    // const wymagania = this.state.buildingDrawTool.limits.ograniczenia;
    // const projekt = this.state.buildingDrawTool.project.data;
  }

  deleteDrawBulding = () => {
    this.props.toggleDrawBuilding(false);
    this.props.drawBuildingGetPoint([]);
    this.props.drawBuildingValidate({ intersect: true, wysokoscMax: null, wrongPoints: [] },
      () =>this.setState({
        daneInvestycji: {
          ...this.state.daneInvestycji,
          projektValid: false,
        },
      }),
    );
  }

  onChangeDachy = (item) => {
    // funkcja przesyła do propsów informacje o projektowanej inwestycji
    const dach = item.target.value;
    const ograniczenia = this.state.buildingDrawTool.limits.ograniczenia
    // this.props.drawBuildingData({
    //   ...this.props.buildingDrawTool.project.data,
    //   dach: dach,
    // });
    if (
      ((ograniczenia.dach_jedno == 'T' && dach == 'jednospadowy') || 
      (ograniczenia.dach_dwu == 'T' && dach == 'dwuspadowy') ||
      (ograniczenia.dach_wielo == 'T' && dach == 'wielospadowy'))
      && dach !== ''
    ) {
      this.setState({
        daneInvestycji: {
          ...this.state.daneInvestycji,
          typDachu: {
            dane: dach,
            valid: true,
          },
        },
      }, () => this.submitProject());
    } else {
      this.setState({
        daneInvestycji: {
          ...this.state.daneInvestycji,
          typDachu: {
            dane: dach,
            valid: false,
          },
          projektValid: false,
        },
      }, () => this.submitProject());
    }
  };

  onChangeKondygnacje = (item) => {
    // funkcja przesyła do propsów informacje o projektowanej inwestycji
    const kond = item.target.value;
    const ograniczenia = this.state.buildingDrawTool.validation;
    if (
      (Number(ograniczenia.wysokoscMax) >= kond && kond !== 0 && kond !== '' && kond !== null)
    ) {
      this.setState({
        daneInvestycji: {
          ...this.state.daneInvestycji,
          kondygnacje: {
            valid: true,
            dane: kond,
          },
        },
      }, () => this.submitProject());
    } else {
      this.setState({
        daneInvestycji: {
          ...this.state.daneInvestycji,
          kondygnacje: {
            valid: false,
            dane: kond,
          },
          projektValid: false,
        },
      }, () => this.submitProject());
    }
  }

  onChangeKatDachu = (item) => {
    const kat = Number(item.target.value);
    const ograniczenia = this.state.buildingDrawTool.limits.ograniczenia;
    // this.props.drawBuildingData({
    //   ...this.props.buildingDrawTool.project.data,
    //   katDachu: kat,
    // });
    if (
      ograniczenia.dach_min <= kat && kat <= ograniczenia.dach_max && kat !== '' && kat !== null
    ) {
      this.setState({
        daneInvestycji: {
          ...this.state.daneInvestycji,
          katDachu: {
            ...this.state.daneInvestycji.katDachu,
            valid: true,
            dane: kat,
          },
        },
      }, () => this.submitProject());
    } else {
      this.setState({
        daneInvestycji: {
          ...this.state.daneInvestycji,
          katDachu: {
            valid: false,
            dane: kat,
          },
          projektValid: false,
        },
      }, () => this.submitProject());
    }
  }

  ograniczeniaKondygnacji = () =>{
    // this.state.buildingDrawTool.limits.ograniczenia.
  }

  printProjectView = () => {
    this.props.setPrintStatus();
    this.props.drawBuildingPDF(true);
  }

  submitProject = () => {
    const state = this.state.daneInvestycji;
    if (!state.projektValid && state.katDachu.valid && state.kondygnacje.valid && state.typDachu.valid) {
      this.setState({
        daneInvestycji: {
          ...state,
          projektValid: true,
        },
      });
    }
    this.props.drawBuildingData({
      ...this.props.buildingDrawTool.project.data,
      katDachu: state.katDachu.dane,
      wysokosc: state.kondygnacje.dane,
      dach: state.typDachu.dane,
    });
  }

  drawBulding = () => {
    // odpalamy narzedzie do projektowania zarysu budynkow i "zerujemy" poprzednie pomiary
    this.props.drawBuildingGetPoint([]);
    this.props.toggleDrawBuilding(true);
  }

  render() {
    const infoOferty = (this.props.sideDescription.data.features[0].properties ? 
      this.props.sideDescription.data.features[0].properties :
    null);
    const info = (this.props.sideDescription.data.features[0].properties ?
      this.props.sideDescription.data.features[0].properties :
    null);
    const {aaa, bbb, ccc, ddd, eee, fff, ggg, hhh, iii } = this.props.intl.langKeys.sidebarInstructions;
    return (
      <div className="desc-content">
        <div className="desc-features">
          <div style={{ display: `${(this.state.buildingDrawTool.project.position.length > 0 && this.state.buildingDrawTool.display === false) ? 'block' : 'none'}` }}>
            <div>
              {!this.state.buildingDrawTool.validation.intersect ? <div className="form-group warning-geom">
                <strong>
                  {this.props.intl.langKeys.geometryWarning}
                  </strong>
              </div> : null}
            </div>
            { this.state.buildingDrawTool.project.position.length !== 0 && !this.state.buildingDrawTool.display ?
              <div className="form-group">
                <button onClick={() => this.deleteDrawBulding()} className="btn btn-danger btn-block perfectCenter marginesy custom-btn">
                  <span key={this.state.intl.langKeys.zapNewInvest} style={{ height: '100%', marginRight: '10px' }}>{this.state.intl.langKeys.zapNewInvest}</span>
                  <span className="fa fa-trash-o fa-2x" aria-hidden="true"></span>
                </button>
                {this.state.buildingDrawTool.validation.intersect && this.state.daneInvestycji.projektValid ? <div className="container rozsun">
                  <form className="col-xs-6" style={{ padding: '0' }} encType="application/json" action={`${process.env.API_URL}/${this.props.district.prefix}/invest3d`} method="post" target="_blank">
                    <input style={{ display: 'none' }} type="text" name="dane3D" value={JSON.stringify(this.props.buildingDrawTool)} />
                    <button onClick={() => this.submitProject()} type="submit" className="btn col-xs-12 btn-info perfectCenter custom-btn" > 
                      <span key={this.state.intl.langKeys.widok3d} style={{ height: '100%', marginRight: '10px' }}>{this.state.intl.langKeys.widok3d}</span>
                      <span className="fa fa-cubes fa-2x" aria-hidden="true"></span>
                    </button>
                  </form>
                  <button onClick={() => this.printProjectView()} className="btn col-xs-6 btn-info perfectCenter custom-btn">
                    <span key={this.state.intl.langKeys.wydruk} style={{ height: '100%', marginRight: '10px' }}>{this.state.intl.langKeys.wydruk}</span>
                    <span className="fa fa-file-image-o fa-2x" aria-hidden="true"></span>
                  </button>
                </div>
              : null
              }
              </div>
            : null }
            <div key={this.state.intl.langKeys.infoInvest} style={{ textAlign: 'justify' }} className="form-group inwest-1_3">
              <strong>{this.state.intl.langKeys.infoInvest}</strong>
            </div>
            <div className={`form-group ${this.state.daneInvestycji.kondygnacje.valid ? '' : 'validate-alert'}`}>
              <label key={this.state.intl.langKeys.wysokoscInvest} htmlFor="exampleInputEmail1">{this.state.intl.langKeys.wysokoscInvest}</label>
              <input onChange={e => this.onChangeKondygnacje(e)} type="number" className="form-control" placeholder="_" />
              {this.state.daneInvestycji.kondygnacje.valid ? null : <label key={this.state.intl.langKeys.zaDuzaWysokosc} className="warning-valid-text" htmlFor="selectRoof">{this.state.intl.langKeys.zaDuzaWysokosc}</label>}
            </div>
            {/* <div className={`form-group ${this.state.daneInvestycji.typDachu.valid ? '' : 'validate-alert'}`}>
              <label key={this.state.intl.langKeys.typDachu} htmlFor="selectRoof">{this.state.intl.langKeys.typDachu}</label>
              <select onChange={(e) => { this.onChangeDachy(e); }} className={`form-control`} name="dachy">
                <option value="" disabled selected>Wybierz...</option>
                <option key={this.state.intl.langKeys.plaskiDach} value="plaski">{this.state.intl.langKeys.plaskiDach}</option>
                <option key={this.state.intl.langKeys.jednoDach} value="jednospadowy">{this.state.intl.langKeys.jednoDach}</option>
                <option key={this.state.intl.langKeys.dwuDach} value="dwuspadowy">{this.state.intl.langKeys.dwuDach}</option>
                <option key={this.state.intl.langKeys.wieloDach} value="wielospadowy">{this.state.intl.langKeys.wieloDach}</option>
              </select>
              {this.state.daneInvestycji.typDachu.valid ? null : <label className="warning-valid-text" htmlFor="selectRoof">Wybrany dach nie jest dopuszczony w MPZP dla wybranej działki</label>}
            </div> */}
            {/* <div className={`form-group ${this.state.daneInvestycji.katDachu.valid ? '' : 'validate-alert'}`}>
              <label key={this.state.intl.langKeys.katDachu} htmlFor="exampleInputEmail1">{this.state.intl.langKeys.katDachu} [<sup>o</sup>]</label>
              <input onChange={e => this.onChangeKatDachu(e)} type="number" className="form-control" placeholder="_" />
              {this.state.daneInvestycji.katDachu.valid ? null : <label className="warning-valid-text" htmlFor="katydachu">Podany kąt nie mieści się w przedziale określonym w MPZP dla wybranej działki</label>}
            </div> */}
          </div>
          <div className="form-group">
            {/* <div style={{ color: '#f95b00', textAlign: 'justify' }} className="form-group inwest-1_3">
              <strong>Pamiętaj by naniesione punkty zawierały się w wybranym obszarze inwestycyjnym!</strong>
            </div> */}
            {/* <div className="form-group">
              Zaprojektowana inwestycja <strong>nie zostanie zaakceptowana</strong> jeżeli nie spełni poniższych wymogów:
              <p></p>
              <ul>
                <li>przekroczenie granic wybranych działek lub/i nieprzekraczalnej linii zabudowy</li>
                <li>zbyt niski wskaźnik powierzchni biologicznie czynnej,</li>
                <li>przekroczenie maksymalnej wysokości budynku,</li>
                <li>zbyt niski lub zbyt wysoki wskaźnik intensywności zabudowy,</li>
                <li>niezgodność  przeznaczenia  zabudowy  z  zapisami  miejscowego  planu zagospodarowania
                  przestrzennego,
                </li>
                <li>przekroczenie liczby kondygnacji,</li>
                <li>niezgodność typu dachu,</li>
                <li>niezgodność  z  planem  w  zakresie  zapisów  dotyczących  maksymalnego
                  poziomego wymiaru gabarytowego budynku, minimalnej szerokości elewacji
                  frontowej budynków, itp.
                </li>
              </ul>
            </div> */}
            {(this.state.buildingDrawTool.project.position.length == 0 && !this.state.buildingDrawTool.display)
            || this.state.buildingDrawTool.display ?
              <div>
                <label key={this.state.intl.langKeys.wybralesTeren} className="inwest-1_3" htmlFor="exampleInputEmail1">
                  {this.state.intl.langKeys.wybralesTeren}:
                  &nbsp;
                  <span className="blueInfo">
                  {this.props.intl.locale === 'pl-PL' ? infoOferty.nazwa : null}
                  {this.props.intl.locale === 'en-EN' ? infoOferty.nazwa_en : null}
                  {this.props.intl.locale === 'de-DE' ? infoOferty.nazwa_de : null}
                  </span>
                </label>
                <div style={{ textAlign: 'justify' }} className="form-group inwest-1_3">
                  {aaa} <strong className="blueInfo">{bbb}</strong> {ccc}
                </div>
                <div style={{ textAlign: 'justify' }} className="form-group inwest-1_3">
                  {ddd} <strong className="blueInfo">{this.props.intl.locale === 'pl-PL' ? infoOferty.nazwa : null}
                  {this.props.intl.locale === 'en-EN' ? infoOferty.nazwa_en : null}
                  {this.props.intl.locale === 'de-DE' ? infoOferty.nazwa_de : null}</strong>
                </div>
                <div style={{ textAlign: 'justify' }} className="form-group inwest-1_3">
                  {eee} <strong className="blueInfo">{fff}</strong>
                </div>
              </div>
                : null
            }
            {this.state.buildingDrawTool.project.position.length == 0 && !this.state.buildingDrawTool.display ?
              <button onClick={() => this.drawBulding()} className="btn btn-primary btn-block perfectCenter custom-btn">
                <span style={{ height: '100%', marginRight: '10px' }}>{this.props.intl.langKeys.rozpocznijProjektowanie}</span>
                <span className="fa fa-object-ungroup fa-2x" aria-hidden="true"></span>
              </button>
              : null }
            {this.state.buildingDrawTool.display ?
              <div>
                <div className="form-group arrow-container">
                  <strong>{this.props.intl.langKeys.naniesPktNaMape}</strong>
                  <div className="fa fa-arrow-right fa-2x arrowAnim" aria-hidden="true"></div>
                </div>
                <button onClick={() => this.stopDrawBulding()} className="btn btn-success btn-block custom-btn">{fff}</button>
                <button onClick={() => this.deleteDrawBulding()} className="btn btn-danger btn-block perfectCenter marginesy custom-btn">
                  <span style={{ height: '100%', marginRight: '10px' }}>{this.props.intl.langKeys.anuluj}</span>
                  <span className="fa fa-trash-o fa-2x" aria-hidden="true"></span>
                </button>
              </div> : null
            }
            <div style={{ textAlign: 'justify', marginTop: '10px' }} className="form-group inwest-1_3">
              {ggg} <strong className="blueInfo">{hhh} </strong>
              {iii}
            </div>
            <div className="dropdown-expander">
              <button onClick={() => { this.setState({ szczegolyCont: !this.state.szczegolyCont }); }}>{this.props.intl.langKeys.szczegoly}&nbsp;<span className="glyphicon glyphicon-menu-down" /></button>
              <div className={`dropdown-expander__content ${this.state.szczegolyCont ? 'rozwin' : null}`}>
                {this.props.renderEinvestInfo()}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

BuildingDraw.propTypes = {
  drawBuildingGetPoint: PropTypes.func,
  toggleDrawBuilding: PropTypes.func,
  drawBuildingData: PropTypes.func,

};
const mapState = (state) => ({
  intl: state.intl,
  sideDescription: state.district.sideDescription,
  district: state.district.district,
  chosenParcel: state.district.chosenParcel,
  buildingDrawTool: state.tools.buildingDrawTool,
});

const mapDispatch = {
  toggleDrawBuilding,
  drawBuildingGetPoint,
  drawBuildingData,
  drawBuildingPDF,
  setPrintStatus,
  drawBuildingValidate,
};


export default withStyles(s)(connect(mapState, mapDispatch)(BuildingDraw));



// WEBPACK FOOTER //
// src/components/Modals/SideDescription/content/BuildingDraw.js